import { cva, VariantProps } from "class-variance-authority";

export const buttonStyles = cva(
  [
    "flex gap-x-2 justify-center items-center",
    "font-medium",
    "focus:ring-2 focus:ring-offset-2 focus:outline-none",
    "rounded-md border border-transparent",
    "relative",
  ],
  {
    variants: {
      underline: {
        default: "",
        underline: "underline",
      },
      width: {
        fitted: "w-fit",
        full: "w-full flex justify-center items-center",
      },
      color: {
        custom: "",
        magenta: "bg-magenta disabled:opacity-50 text-white focus:ring-magenta",
        navy: "bg-navy disabled:opacity-50 text-white focus:ring-navy",
        secondary: "bg-secondary disabled:opacity-50 focus:ring-secondary",
        tertiary:
          "text-navy bg-tertiary disabled:opacity-100 disabled:bg-[#E6ECF5] disabled:text-[#839BAF]",
        quarternary:
          "bg-secondary text-[#CF251D] disabled:opacity-100 disabled:text-gray-6",
        destructive:
          "bg-destructive text-white disabled:opacity-50 focus:ring-destructive",
        ghost: "bg-ghost text-current hover:bg-[#F6F6F6] disabled:opacity-50",
        "ghost-navy":
          "bg-ghost text-navy hover:bg-[#F6F6F6] disabled:opacity-50",
        "ghost-magenta":
          "bg-ghost text-magenta hover:bg-[#F6F6F6] disabled:opacity-50",
        eskimo: "bg-friendly-eskimo text-navy",
        "ghost-destructive":
          "bg-ghost text-destructive hover:text-destructive hover:bg-[#F6F6F6] disabled:opacity-50",
        outline:
          "!border-dublin-gray bg-transparent disabled:opacity-50 text-charcoal",
        "outline-white": "!border-dublin-gray bg-white disabled:opacity-50",
      },
      size: {
        custom: "",
        large: "px-6 py-4 text-lg font-semibold",
        standard: "px-4 py-2 text-base font-semibold",
        micro: "px-3 py-2 text-sm font-medium",
        iconStandard: "px-3 py-3 text-lg font-semibold",
        iconMicro:
          "max-w-[40px] w-full flex !h-10 text-lg font-semibold flex-shrink-0",
        // TODO: Need to rename / consolidate these after design system clean up starts
        squareIconSmall: "!w-8 !h-8 flex-shrink-0",
      },

      wrapText: {
        default: "",
        nowrap: "whitespace-nowrap",
      },
    },
    defaultVariants: {
      color: "magenta",
      size: "standard",
      width: "fitted",
      wrapText: "default",
      underline: "default",
    },
  },
);

export type ButtonStylesProps = VariantProps<typeof buttonStyles>;
